import React from "react";
var __jsx = React.createElement;
import { Icon } from "@syarahtech/ui";
import { useCart } from "@/common/Contexts/CartContext";
import { useLang } from "@/common/Contexts/LanguageContext";
var ShareIcon = function ShareIcon() {
  return /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--ios-share-rounded",
    className: "text-primary-new",
    width: 5,
    height: 5
  });
};
var CartIconSvg = function CartIconSvg() {
  return /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--shopping-cart-outline-rounded",
    className: "text-primary-new",
    width: 6,
    height: 6
  });
};
var MobilePageHeader = function MobilePageHeader(_ref) {
  var backUrl = _ref.backUrl,
    onShare = _ref.onShare;
  var _useCart = useCart(),
    totalItems = _useCart.totalItems;
  var lang = useLang();
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between px-4 py-3 bg-white border-solid border-b border-[#E1E8F2]"
  }, /*#__PURE__*/React.createElement("a", {
    href: backUrl,
    className: "flex items-center justify-center w-9 h-9 rounded-xl hover:bg-[#F4F6FB] transition-colors"
  }, lang == "en" ? /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-back-ios-rounded",
    className: "text-primary-new",
    width: 4,
    height: 4
  }) : /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-forward-ios-rounded",
    className: "text-primary-new",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center "
  }, __IS_CSR__ && totalItems > 0 && /*#__PURE__*/React.createElement("a", {
    href: "/site/cart",
    onClick: function onClick(e) {
      if (typeof window !== "undefined" && window.location.pathname.includes("/site/cart")) {
        e.preventDefault();
      }
    },
    className: "relative flex items-center justify-center w-9 h-9 rounded-xl hover:bg-[#F4F6FB] transition-colors"
  }, /*#__PURE__*/React.createElement(CartIconSvg, null), /*#__PURE__*/React.createElement("span", {
    className: "absolute -top-1 -left-1 min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full bg-[#EC6234] text-white text-[10px] font-bold leading-none"
  }, totalItems > 99 ? "99+" : totalItems)), onShare && /*#__PURE__*/React.createElement("div", {
    onClick: onShare,
    className: "flex items-center justify-center w-9 h-9 rounded-xl hover:bg-[#F4F6FB] "
  }, /*#__PURE__*/React.createElement(ShareIcon, null))));
};
export default MobilePageHeader;